import React, { memo, useCallback } from "react";
import ImageMC from "../../../components/ImageMC";

// Memoized replied image message component
export const RepliedImageMessageMC = memo(({ conversation, message, onImageClick }) => {
  const handleClick = useCallback(() => {
    onImageClick(message.id || message.identifier);
  }, [onImageClick, message.id, message.identifier]);

  return (
    <ImageMC
      platform={conversation.platform}
      data={message}
      onClick={handleClick}
      className="tw-max-w-[100px] tw-max-h-[100px] tw-mt-[5px] tw-cursor-pointer"
    />
  );
});

RepliedImageMessageMC.displayName = "RepliedImageMessageMC";

export default RepliedImageMessageMC;
